(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);

      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);

      clearTimeout(this.exitTimer);
    }

    onEnter() {
      if (this.header) {
        this.header.classList.add('is-active');
      }

      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        if (this.header) {
          this.header.classList.remove('is-active');
        }
      }, 400);
    }
  }

  if (!customElements.get('header-wrapper')) {
    customElements.define('header-wrapper', HeaderWrapper);
  }

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isScrolling = null;

      this.onScrollHandler = this.onScroll.bind(this);

      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback();

      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );

      window.clearTimeout(this.isScrolling);
    }

    createObserver() {
      if (!this.header) return;

      var observer = new IntersectionObserver(
        (entries, observerInstance) => {
          if (!entries || !entries[0]) return;

          this.headerBounds = entries[0].intersectionRect;

          if (
            this.headerBounds.top === 0 &&
            this.headerBounds.bottom === 0
          ) {
            var scrollTop =
              window.pageYOffset ||
              document.documentElement.scrollTop;

            var boundingClientRect =
              entries[0].boundingClientRect;

            this.headerBounds = {
              top: scrollTop + boundingClientRect.top,
              bottom: scrollTop + boundingClientRect.bottom
            };
          }

          if (this.dataset.scrollUp !== undefined) {
            this.scrollUpActive = true;
          }

          observerInstance.disconnect();
        }
      );

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.header) return;

      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      var headerBottom =
        this.headerBounds &&
        typeof this.headerBounds.bottom === 'number'
          ? this.headerBounds.bottom
          : 0;

      var headerTop =
        this.headerBounds &&
        typeof this.headerBounds.top === 'number'
          ? this.headerBounds.top
          : 0;

      if (
        (window.theme &&
          theme.config &&
          theme.config.mqlSmall) ||
        this.scrollUpActive
      ) {
        if (
          scrollTop > this.currentScrollTop &&
          scrollTop > headerBottom
        ) {
          requestAnimationFrame(
            this.hide.bind(this)
          );
        } else if (
          scrollTop < this.currentScrollTop &&
          scrollTop > headerBottom
        ) {
          if (!this.preventReveal) {
            requestAnimationFrame(
              this.reveal.bind(this)
            );
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(
              this.hide.bind(this)
            );
          }
        } else if (scrollTop <= headerTop) {
          requestAnimationFrame(
            this.reset.bind(this)
          );
        }
      } else {
        if (scrollTop > headerBottom) {
          if (this.sticky()) {
            this.currentScrollTop = scrollTop;
            return;
          }

          requestAnimationFrame(
            this.hide.bind(this)
          );

          setTimeout(() => {
            requestAnimationFrame(
              this.reveal.bind(this)
            );
          }, 300);
        } else if (scrollTop <= headerTop) {
          requestAnimationFrame(
            this.reset.bind(this)
          );
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (!this.header) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      document.body.classList.add(
        'shopify-body-section-header-hidden',
        'shopify-body-section-header-sticky'
      );
    }

    reveal() {
      if (!this.header) return;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );

      document.body.classList.add(
        'shopify-body-section-header-sticky'
      );

      document.body.classList.remove(
        'shopify-body-section-header-hidden'
      );
    }

    reset() {
      if (!this.header) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

      document.body.classList.remove(
        'shopify-body-section-header-hidden',
        'shopify-body-section-header-sticky'
      );
    }

    sticky() {
      if (!this.header) return false;

      return (
        this.header.classList.contains(
          'shopify-section-header-sticky'
        ) &&
        !this.header.classList.contains(
          'shopify-section-header-hidden'
        ) &&
        document.body.classList.contains(
          'shopify-body-section-header-sticky'
        ) &&
        !document.body.classList.contains(
          'shopify-body-section-header-hidden'
        )
      );
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define(
      'sticky-header',
      StickyHeader
    );
  }

  } catch(e) { console.error(e); }
})();
})();
